export default "__VITE_ASSET__CD28q5fW__";